import { ISykFieldInfo } from '../../modules/VerificationPage/store/verification.types';

export default class SykFieldInfo {
  // eslint-disable-next-line class-methods-use-this
  /* eslint-disable no-param-reassign */
  public static mapTranslationKeys(sykFieldInfo: ISykFieldInfo, prefix: string): void {
    sykFieldInfo.body = `${prefix}.${sykFieldInfo.body}`;
    sykFieldInfo.label = `${prefix}.${sykFieldInfo.label}`;
    sykFieldInfo.hint = `${prefix}.${sykFieldInfo.hint}`;
    sykFieldInfo.validator.name = `${prefix}.${sykFieldInfo.validator.name}`;
  }
}
